<i18n>
en:
  title:
    user: "Sign up"
    shop: "Store entry"
ja:
  title:
    user: "ユーザーの 新規作成"
    shop: "店舗の 新規登録"
</i18n>

<template lang="pug">
  div
    //- タイトル
    v-img(:src="require(`@/assets/images/header-back-entry-${kind}.png`)" min-height="180px")
      v-row.fill-height(align="center")
        v-col(align="center")
          h1.white--text|{{$t(`title.${kind}`)}}

    //- サブビュー
    router-view
</template>

<script>
export default {
  computed: {
    /**
     * ユーザー種別
     */
    kind () {
      switch (this.$route.name) {
        case 'EntryFirst':
        case 'EntryComplete':
          if (this.$route.params.kind === '1') {
            return 'shop'
          }
          break
        case 'ShopEntry':
          return 'shop'
      }
      return 'user'
    }
  }
}
</script>

<style lang="sass" scoped>
h1
  font-size: 48px
  word-break: keep-all
</style>
